























import { Vue, Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import LanguageSelector from '../components/LanguageSelector.vue';

@Component({
    components: {
        LanguageSelector,
    },
    computed: mapState(['dashboard']),
})
export default class AppHeader extends Vue {
    public dashboard!: any;

    /* istanbul ignore next */
    public get isSmallView() {
        return this.$store.getters.isSmallView;
    }
}
